import React, { useState, useEffect } from 'react';
import InputRange from 'react-input-range';

import styles from './styles.module.css';
import './index.css';

function RangeSlider({ title, currentValue, min, max, step, onChange, width = '100%' }) {
  const [value, setValue] = useState(currentValue);

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue])

  function change(value) {
    setValue(value);
    onChange(value);
  }

  return (
  <div style={{
    width: width,
    marginBottom: '40px'
  }} className={[styles.mT, styles.mB].join(' ')}>
    {title && title.trim() !== '' ? <label>{title}</label> : null}
    <InputRange
        maxValue={max}
        minValue={min}
        value={value}
        step={step}
        onChange={value => change(value)} />
  </div>
  );
}

export default RangeSlider;
